/**
 * ASCII Style Presets
 *
 * Predefined character sets for different aesthetic styles.
 * Each style has a unique set of characters sorted by density.
 */

export const asciiStyles = {
  classic: {
    id: 'classic',
    name: 'Classic',
    characterSet: '█▓▒░·∙˙¨ ',
    description: 'Traditional block-based ASCII art'
  },
  technical: {
    id: 'technical',
    name: 'Technical',
    characterSet: '@#$%&*+=-:. ',
    description: 'Code and programming aesthetic'
  },
  dots: {
    id: 'dots',
    name: 'Dots',
    characterSet: '●◉◎○◌◦∘· ',
    description: 'Circular patterns with dots'
  },
  blocks: {
    id: 'blocks',
    name: 'Blocks',
    characterSet: '█▇▆▅▄▃▂▁ ',
    description: 'Vertical block gradients'
  },
  binary: {
    id: 'binary',
    name: 'Binary',
    characterSet: '10 ',
    description: 'Digital binary pattern'
  },
  matrix: {
    id: 'matrix',
    name: 'Matrix',
    characterSet: 'ﾊﾐﾋｰｳｼﾅﾓﾆｻﾜﾂｵﾘｱﾎﾃﾏｹﾒｴｶｷﾑﾕﾗｾﾈｽﾀﾇﾍ ',
    description: 'Katakana matrix rain effect'
  },
  minimal: {
    id: 'minimal',
    name: 'Minimal',
    characterSet: '■□ ',
    description: 'Simple two-tone squares'
  },
  arrows: {
    id: 'arrows',
    name: 'Arrows',
    characterSet: '▶▷►▻▸▹‣› ',
    description: 'Directional arrow patterns'
  }
};

export const asciiStyleKeys = Object.keys(asciiStyles);

export const getStyleById = (id) => asciiStyles[id] || asciiStyles.classic;
